var _g, _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 157,
    viewBox: "0 0 158 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_8_11341)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 78.8634,
    cy: 78.8634,
    r: 57,
    transform: "rotate(-30 78.8634 78.8634)",
    fill: "white",
    fillOpacity: 0.1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78.8634,
    cy: 78.8634,
    r: 56.5,
    transform: "rotate(-30 78.8634 78.8634)",
    stroke: "white",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.9824 93.2293L103.748 66.2293L102.748 64.4973L55.9824 91.4973L56.9824 93.2293ZM79.8814 59.3987C81.7461 61.7259 85.1142 64.8682 89.2165 66.7679C93.3409 68.6778 98.3105 69.3686 103.184 66.5546L102.184 64.8226C98.0432 67.2135 93.7938 66.6835 90.0569 64.953C86.2978 63.2123 83.1621 60.2946 81.4422 58.1481L79.8814 59.3987ZM98.5936 87.8551C97.5946 85.2924 96.6356 81.1179 97.0076 76.9921C97.3775 72.8906 99.0432 68.9455 103.184 66.5546L102.184 64.8226C97.3105 67.6365 95.4239 72.2857 95.0157 76.8125C94.6097 81.315 95.647 85.803 96.7301 88.5815L98.5936 87.8551Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_8_11341",
    x: -8.14606,
    y: -8.146,
    width: 174.019,
    height: 174.019,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8_11341"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8_11341",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHover);
export default __webpack_public_path__ + "static/media/hover.e6fa5b99f7e313805398784ec4bdab04.svg";
export { ForwardRef as ReactComponent };